/**
 * Game-related translations for Spanish language
 * This file contains translations for game mechanics, stages, and end reasons
 */
export default {
  game: {
    winner: 'Ganador',
    evil: 'malvado',
    good: 'bueno',
    stage: 'etapa',
    voteStage: 'Etapa de votación',
    voting: 'votación',
    excalibur: 'excalibur',
    'team building': 'formación de equipo',
    mission: 'misión',
    initialization: 'inicialización',
    'lady of lake': 'dama del lago',
    'check loyalty': 'verificar lealtad',
    'witch loyalty': 'lealtad de la bruja',
    'announce loyalty': 'anunciar lealtad',
    'give card': 'dar carta',
    'lead to victory': 'liderar hacia la victoria',
    'restore honor': 'restaura tu honor',
    'king returns': 'el rey regresa',
    'play card': 'jugar carta',
    'reveal loyalty': 'revelar lealtad',
    'we found you': 'te encontramos',
    ambush: 'emboscada',
    end: 'fin',
    lancelots: 'lancelotes',
    witch: 'bruja',
    assassinate: 'asesinar',
    hidden: 'oculto',
    historyMode: 'Modo historia',
    gameIsEnded: 'El juego ha terminado',
    rolesAndAddons: 'Roles y expansiones',
  },
  endReason: {
    manualy: 'El juego se terminó manualmente',
    evilTeamMissions: 'El equipo malvado falló 3 misiones',
    goodTeamMissions: 'El equipo bueno completó 3 misiones con éxito',
    missMerlin: 'El equipo malvado intentó matar a Merlín pero falló',
    missGuinevere: 'El equipo malvado intentó matar a Ginebra pero falló',
    missLovers: 'El equipo malvado intentó matar a los Amantes pero falló',
    missCleric: 'El equipo maligno intentó matar al Clérigo + 1 pero falló',
    killCleric: 'El equipo maligno mató al Clérigo + 1',
    killGuinevere: 'El equipo malvado mató a Ginebra',
    killLovers: 'El equipo malvado mató a los Amantes',
    killMerlin: 'El equipo malvado mató a Merlín',
    rejectedVote: 'El equipo malvado saboteó la votación',
  },
};
